export const goBack = () => {
    window.history.back();
};



// WEBPACK FOOTER //
// ./src/services/navigation/navigation-service.js